import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { PerformanceRun, PerformanceRunEquipList, PerformanceRunPayload } from './performance-run.interface';

@Injectable({
  providedIn: 'root',
})
export class PerformanceRunService {
  constructor(private _http: HttpClient) {}

  getPerformanceRunData(body: PerformanceRunPayload): Observable<PerformanceRun> {
    return this._http
      .post<any>(`${environment.servicePath}/performance_run/get_performance_run_values`, body, {
        headers: this._authenticatedHeader(),
      })
      .pipe(
        take(1),
        map((data) => this._mappingPerformanceRunData(data))
      );
  }

  getPerformanceRunEquipList(body: PerformanceRunPayload): Observable<PerformanceRunEquipList> {
    return this._http
      .post<any>(`${environment.servicePath}/performance_run/performance_run_equip_list`, body, {
        headers: this._authenticatedHeader(),
      })
      .pipe(
        take(1),
        map((data) => this._mappingPerformanceRunEquipList(data))
      );
  }

  savePerformanceRun(body: any): Observable<any> {
    return this._http
      .post<any>(`${environment.servicePath}/performance_run/save_and_publish_performance_run`, body, {
        headers: this._authenticatedHeader(),
      })
      .pipe(
        take(1),
        map((data) => data)
      );
  }

  private _authenticatedHeader() {
    const _token = sessionStorage.getItem('vtTokenKey') || localStorage.getItem('vtTokenKey');
    let _header = new HttpHeaders();
    _header = _header.set('Authorization', `Bearer ${_token}`);
    _header = _header.set('Content-Type', 'application/json');
    return _header;
  }

  private _mappingPerformanceRunEquipList(response: PerformanceRunEquipList): PerformanceRunEquipList {
    return {
      ...response,
      performanceRunAssetsList: response.performanceRunAssetsList.map((item) => ({
        ...item,
        isClickedOnPublish: false,
      })),
    };
  }

  private _mappingPerformanceRunData(performanceRunData: any): PerformanceRun {
    let savedPerformanceRunValues!: any[];
    let savedPerformanceRunValues_high!: any[];
    let savedPerformanceRunLayout!: string;
    let isEnabled: boolean | undefined | string;
    let sixRowDefaultValues!: any[];
    let tenRowDefaultValues!: any[];
    let tenRowDefaultValues_high!: any[];
    let sixRowDefaultValues_high!: any[];
    let savedPerformanceRunId!: string;
    let visibleSixRowLayoutValues: any[] = [];
    let visibleTenRowLayoutValues: any[] = [];
    let visibleSixRowLayoutValues_high: any[] = [];
    let visibleTenRowLayoutValues_high: any[] = [];
    let layoutType!: string;
    let showSixRowLayout!: boolean;
    let showTenRowLayout!: boolean;

    performanceRunData?.performanceRunList?.forEach((performanceItem: any) => {
      if (performanceItem.facilityId) {
        savedPerformanceRunValues = performanceItem.performanceRunKeys;
        savedPerformanceRunValues_high = performanceItem.performanceRunHighKeys;
        savedPerformanceRunLayout = performanceItem.layout;
        isEnabled = performanceItem.enabled;
        savedPerformanceRunId = performanceItem.id;
      } else {
        if (performanceItem.layout === '6') {
          sixRowDefaultValues = performanceItem.performanceRunKeys;
          sixRowDefaultValues_high = performanceItem.performanceRunHighKeys;
        } else if (performanceItem.layout === '10') {
          tenRowDefaultValues = performanceItem.performanceRunKeys;
          tenRowDefaultValues_high = performanceItem.performanceRunHighKeys;
        }
        if (isEnabled === '') {
          isEnabled = performanceItem.enabled;
        }
      }
    });
    if (savedPerformanceRunLayout === '6') {
      visibleSixRowLayoutValues = savedPerformanceRunValues;
      visibleTenRowLayoutValues = tenRowDefaultValues;
      visibleSixRowLayoutValues_high = savedPerformanceRunValues_high;
      visibleTenRowLayoutValues_high = tenRowDefaultValues_high;
      layoutType = '6';
      showSixRowLayout = true;
      showTenRowLayout = false;
    } else if (savedPerformanceRunLayout === '10') {
      visibleSixRowLayoutValues = sixRowDefaultValues;
      visibleTenRowLayoutValues = savedPerformanceRunValues;
      visibleSixRowLayoutValues_high = sixRowDefaultValues_high;
      visibleTenRowLayoutValues_high = savedPerformanceRunValues_high;
      layoutType = '10';
      showSixRowLayout = false;
      showTenRowLayout = true;
    } else {
      visibleSixRowLayoutValues = sixRowDefaultValues;
      visibleTenRowLayoutValues = tenRowDefaultValues;
      visibleSixRowLayoutValues_high = sixRowDefaultValues_high;
      visibleTenRowLayoutValues_high = tenRowDefaultValues_high;
      layoutType = '6';
      showSixRowLayout = true;
      showTenRowLayout = false;
    }
    return {
      savedPerformanceRunId,
      visibleSixRowLayoutValues,
      visibleTenRowLayoutValues,
      visibleSixRowLayoutValues_high,
      visibleTenRowLayoutValues_high,
      layoutType,
      showSixRowLayout,
      showTenRowLayout,
      preferredUnit: performanceRunData.preferredUnit,
      speedMaxVal: performanceRunData.preferredUnit === 'I' ? 14 : 23,
      speedMaxVal_std: performanceRunData.preferredUnit === 'I' ? 15 : 24,
      speedMaxVal_high: performanceRunData.preferredUnit === 'I' ? 18 : 29,
      speedMinVal: 1,
      speedMinVal_std: 1,
      speedMinVal_high: 1,
      inclineMinVal: 0,
      inclineMaxVal: 15,
      inclineMinVal_std: -3,
      inclineMaxVal_std: 20,
      inclineMinVal_high: -3,
      inclineMaxVal_high: 20,
    };
  }
}
